// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__24sv4","blocked":"Modal_blocked__1F2Ll","backDrop":"Modal_backDrop__3k2KO","content":"Modal_content__KP_v5"};